
<template>
    <div>
        <!-- 脚部 -->
        <!-- 读文档发现，fixed这个prop，控制tabbar是否是固定定位，脱离文档流
             这里要设置成false，否则滚动条捅进tabbar里，而且tabbar还遮挡部分main
            的内容  -->
        <van-tabbar v-model="active" :fixed="false" @change="handleTabChange">
            <van-tabbar-item icon="home-o">ホーム</van-tabbar-item>
            <van-tabbar-item icon="description-o">購入履歴</van-tabbar-item>
            <van-tabbar-item icon="like-o">お気に入り</van-tabbar-item>
            <van-tabbar-item icon="shopping-cart-o">買い物かご</van-tabbar-item>
            <van-tabbar-item icon="chat-o">メッセージ</van-tabbar-item>
            <van-tabbar-item icon="user-o">個人</van-tabbar-item>
        </van-tabbar>

        <van-tabbar route>
          <van-tabbar-item replace to="/home" icon="home-o">ホーム</van-tabbar-item>
          <van-tabbar-item replace to="/records" icon="description-o">購入履歴</van-tabbar-item>
          <van-tabbar-item replace to="/like" icon="like-o">お気に入り</van-tabbar-item>
          <van-tabbar-item replace to="/cart" icon="shopping-cart-o">買い物かご</van-tabbar-item>
          <van-tabbar-item replace to="/message" icon="chat-o">メッセージ</van-tabbar-item>
          <van-tabbar-item replace to="/profile" icon="user-o">個人</van-tabbar-item>
        </van-tabbar>
    </div>
</template>
<script>
export default {
    name: "TabBar",
    data() {
        return {
            active: 0,
        }
    },
    methods: {
        // 切换tabbar标签时的回调,
        // activeIndex是vantUI底层给咱们传过来的回调参数，是被点击tab在数组中的索引值。
        handleTabChange(activeIndex) {
            // 这里定义一个数组，里面是要跳转的路由路径
            const routes = ['/home', '/records', '/message', '/profile'];
            // $router在vue实例身上，用它身上的.push方法, 可以跳转路由路径
            // 其中 .push是往盛放路由路径的地方，添加进去一个新的路径，不影响旧的路径
            // .replace是替换掉之前最后一个旧路径
            this.$router.push(routes[activeIndex]);
        }
    }
}
</script>
<style scoped>

</style>